"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEntityKey = void 0;
exports.isNumericType = isNumericType;
exports.isDateType = isDateType;
exports.isDateTimeType = isDateTimeType;
exports.isBooleanType = isBooleanType;
exports.isStringType = isStringType;
const Metadata_1 = require("./Metadata");
const parseEntityKey = (path) => {
    var _a;
    const regExp = /(?<path>[^(]+)(\('?(?<key>[^)]+)'?\))?/;
    const matches = regExp.exec(path);
    let key = (_a = matches.groups) === null || _a === void 0 ? void 0 : _a.key;
    let keyProp;
    if (key !== undefined && key !== null && key.indexOf("=") >= 0) {
        [keyProp, key] = key.split("=");
    }
    key = key === null || key === void 0 ? void 0 : key.replace(/'/g, "");
    return {
        path: matches.groups.path,
        key: key,
        keyProp
    };
};
exports.parseEntityKey = parseEntityKey;
const isOneOfTypes = (type, testTypes) => {
    if (type instanceof Metadata_1.Property) {
        type = type.getType().getName();
    }
    return testTypes.includes(type);
};
function isNumericType(type) {
    return isOneOfTypes(type, ["Byte", "SByte", "Int16", "Int32", "Int64", "Single", "Double", "Decimal"]);
}
function isDateType(type) {
    return isOneOfTypes(type, ["Date", "DateTimeOffset", "TimeOfDay"]);
}
function isDateTimeType(type) {
    return isOneOfTypes(type, ["DateTimeOffset"]);
}
function isBooleanType(type) {
    return isOneOfTypes(type, ["Boolean"]);
}
function isStringType(type) {
    return isOneOfTypes(type, ["String", "Guid"]);
}
